import React from "react";
// import TransactionDetailsCard from "./../../Components/TransactionDetails/TransactionDetailsCard";
import { TransactionItem } from "../../Components/TransactionDetails/TransactionDetails";
import { EmptyTransaction } from "./../../Public/assets/index";

const RecentTransactions = ({ noPayment, data }) => {
  return (
    <div
      className={`bg-white py-[26px] rounded-lg  lg:shadow-minShadow  w-full ${
        noPayment ? "h-full " : "h-full"
      }    font-geomanist text-sm leading-tight`}
    >
      {!noPayment ? (
        <>
          <h2 className="px-6 mb-3 text-xl font-geomanistBold text-blackShade">
            Recent Transactions
          </h2>
          <div className="space-y-2 ">
            {data
              // ?.filter((transaction) => transaction.transaction_type !== "FEES")
              ?.slice(0, 4)
              ?.map((transaction, index) => (
                <TransactionItem key={index} {...transaction} />
              ))}
          </div>
        </>
      ) : (
        <>
          <h2 className="px-6 mb-6 text-xl font-geomanistBold text-blackShade">
            Recent Transactions
          </h2>

          <div className="flex  pt-6 lg:pt-12 gap-[10px] md:gap-2.5 flex-col justify-center items-center ">
            <img src={EmptyTransaction} alt="" />
            {/* text-lg lg:text-3xl  */}
            <h1 className="font-geomanistBold mt-[16px] text-[26px]  leading-[26px] lg:text-[32px]  md:leading-[32px] text-blackShade">
              No Transactions
            </h1>
            {/* text-lg lg:text-3xl  */}
            <h3 className="font-geomanistBold text-[18px] leading-[18px] md:text-[24px] md:leading-[24px] text-greyish">
              Transactions will be shown here
            </h3>
          </div>
        </>
      )}
    </div>
  );
};

export default RecentTransactions;
